import React from 'react';

const CommsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0,0,256,256">
        <g fill="currentColor" fillRule="nonzero" stroke="none" strokeWidth={1} strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit={10} strokeDasharray="" strokeDashoffset={0} fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: 'normal' }}>
            <g transform="scale(4,4)">
                <path d="M32,10c13.785,0 25,8.951 25,19.954c0,11.003 -11.215,19.953 -25,19.953c-0.646,0 -1.311,-0.022 -1.983,-0.065c-7.369,5.504 -13.411,6.251 -13.672,6.281c-0.076,0.009 -0.152,0.013 -0.228,0.013c-0.7,0 -1.356,-0.368 -1.72,-0.979c-0.402,-0.678 -0.369,-1.528 0.084,-2.172c0.023,-0.033 1.966,-2.8 4.003,-6.234c-7.138,-3.647 -11.484,-9.924 -11.484,-16.797c0,-11.003 11.215,-19.954 25,-19.954zM32,45.907c11.579,0 21,-7.157 21,-15.954c0,-8.797 -9.421,-15.953 -21,-15.953c-11.579,0 -21,7.157 -21,15.954c0,5.86 4.242,11.243 11.071,14.046c0.529,0.217 0.939,0.65 1.128,1.19c0.189,0.54 0.138,1.135 -0.142,1.634c-0.749,1.343 -1.521,2.635 -2.236,3.787c2.061,-0.888 4.615,-2.27 7.363,-4.401c0.398,-0.31 0.9,-0.458 1.4,-0.412c0.825,0.073 1.638,0.109 2.416,0.109z"/>
            </g>
        </g>
    </svg>
);

type CommsToggleButtonProps = {
    active: boolean,
    unreadCount: number,
    onClick: () => void
}

export const CommsToggleButton = ({ active, unreadCount, onClick }: CommsToggleButtonProps) => (
    <button
        type="button"
        data-testid="offer-conversation-only-toggle"
        onClick={onClick}
        className={`ml-4 inline-flex items-center gap-1 px-3 py-2 text-bold font-medium leading none rounded focus:outline-none
            ${active ? 'bg-purple-300 text-purple-700' : 'bg-purple-200 text-purple-300 hover:bg-purple-300 hover:text-purple-700'}`}
    >
        <CommsIcon/>
        <span>{`Comms (${unreadCount})`}</span>
        {unreadCount > 0 && (
            <span className="ml-1 h-2 w-2 rounded-full bg-red-500"/>
        )}
    </button>
);
